import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbAuthSimpleToken, NbAuthStrategy, NbDummyAuthStrategy } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of as observableOf } from 'rxjs';

import { throwIfAlreadyLoaded } from './module-import-guard';


import { FirebaseAuthStrategy } from '../auth/firebase-auth-strategy';
import { CustomLoginComponent } from '../auth/custom-login/custom-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbInputModule, NbButtonModule, NbCardModule, NbAlertModule, NbCheckboxModule, NbIconModule, NbSelectModule } from '@nebular/theme';
import { CustomRegisterComponent } from '../auth/custom-register/custom-register.component';
import { CustomForgotPasswordComponent } from '../auth/custom-forgot-password/custom-forgot-password.component';




export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf('guest');
  }
}
const authModule = NbAuthModule.forRoot({

    strategies: [
      FirebaseAuthStrategy.setup({
        name: 'email',
            token: {
        class: NbAuthSimpleToken, // 👈 Here as well
      }
      }),
    ],
    forms: {
      login: {
              component: CustomLoginComponent,  // 👈 THIS replaces default login page

            },
            register: {

              component: CustomRegisterComponent,  // 👈 THIS replaces default login page
      },
        requestPassword: {
    component: CustomForgotPasswordComponent, // ✅
  },
    },
  });
  const security =   NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  });
export const NB_CORE_PROVIDERS = [
  ...(authModule.providers || []),
  ...(security.providers || []),



  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },
,    FormsModule,            // <-- needed for ngModel and ngForm
    ReactiveFormsModule,NbInputModule, NbButtonModule, NbCardModule, NbAlertModule, NbCheckboxModule, NbIconModule, NbSelectModule
];

@NgModule({
  imports: [
    CommonModule,
    NbAuthModule,
    FormsModule,             //  ⭐ REQUIRED for ngModel
    NbAuthModule,
        NbInputModule,


],
  exports: [
    NbAuthModule,CustomLoginComponent,CustomRegisterComponent,CustomForgotPasswordComponent
  ],
  declarations: [CustomLoginComponent,CustomRegisterComponent,CustomForgotPasswordComponent],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

static forRoot(): ModuleWithProviders<CoreModule> {
  return {
    ngModule: CoreModule,
    providers: [
  ...NB_CORE_PROVIDERS.filter(p => p != null),
      FirebaseAuthStrategy
    ],
  };
}
}
